import TitlePage from "@components/atoms/TitlePage/TitlePage";
import GenericTable from "../GenericTable/GenericTable";
import { IClientsUI } from "src/types/organisms";
import ErrorAlert from "@components/atoms/ErrorAlert/ErrorAlert";
const ClientsUI = ({
  isLoading,
  showError,
  closeError,
  errorMessage,
  headers,
  rows,
  onClick,
  pages,
  currentPage,
  onChangePage,
  onSearch,
  onSearchClick
}: IClientsUI) => {
  return <>
      <TitlePage title="Clientes" subtitle="Control total sobre tu base de clientes. Editar, agregar y organizar nunca ha sido tan sencillo." />
      <GenericTable isLoading={isLoading} title="Lista de clientes" buttonLabel="Crear cliente" onClick={onClick} headers={headers} rows={rows} pages={pages} currentPage={currentPage} onChangePage={onChangePage} emptyMessage="Sin clientes encontrados" searchLabel="Buscar cliente" onSearch={onSearch} onSearchClick={onSearchClick} />
      <ErrorAlert open={showError} onClose={closeError} message={errorMessage} />
    </>;
};
export default ClientsUI;